import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">欢迎来到ToopVIP</h1>
        <p className="text-xl text-gray-600 mb-8">
          让视频成为企业的窗口
          让流量体现品牌的价值
        </p>
        <button
          onClick={() => window.location.href = '/promotion_vip'}
          className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700"
        >
          了解更多
        </button>
      </div>
    </section>
  );
};

export default Hero; 